export default __webpack_public_path__ + "static/media/forgotimage.aada6955.png";